import type { Simulation } from '../../core/simulation/Simulation';
import type { Coordinate } from '../../core/types/SimulationTypes';
import { MathUtils } from '../../utils/MathUtils';

export class WaterTool {
  private brushSize: number = 3;
  private strength: number = 2.0;

  public setBrushSize(size: number): void {
    this.brushSize = MathUtils.clamp(size, 1, 20);
  }

  public getBrushSize(): number {
    return this.brushSize;
  }

  public setStrength(strength: number): void {
    this.strength = MathUtils.clamp(strength, 0.1, 10);
  }

  public getStrength(): number {
    return this.strength;
  }

  public apply(simulation: Simulation, worldCoord: Coordinate): void {
    simulation.addWater(worldCoord.x, worldCoord.y, this.strength, this.brushSize);
  }
}
